import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { HeadingComponent } from '@uigy/shared/components/heading/heading.component';
import { UIButtonTextComponent } from '@uigy/shared/components/ui-button/button-text/ui-button-text.component';
import { UiGridComponent } from '@uigy/shared/components/ui-grid/components/ui-grid/ui-grid.component';
import { UiGridOptions } from '@uigy/shared/components/ui-grid/models/ui-grid';
import { Router } from '@angular/router';
import { IconsEnum } from '@uigy/generated/icons.enum';

@Component({
    selector: 'app-table-card',
    imports: [
        HeadingComponent,
        UIButtonTextComponent,
        UiGridComponent
    ],
    templateUrl: './table-card.component.html',
    styleUrl: './table-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableCardComponent<T, G>  {
  private router = inject(Router);

  public title = input<string>();
  public buttonLabel = input<string>();
  public buttonIcon = input<IconsEnum>();
  public buttonNavigateTo = input<string>('/');
  public gridOptions = input<UiGridOptions<T,G>>();

  public handleClick(): void {
    this.router.navigateByUrl(this.buttonNavigateTo());
  }

}
